import React from 'react';

const GoogleLoginButton = ({ handleGoogleLogin }) => {
  return (
    <button
      onClick={handleGoogleLogin}
      className="auth-button google w-full flex items-center justify-center gap-2 bg-white hover:bg-blue-100 text-black py-2 px-4 rounded-lg mb-4 shadow-sm"
      style={{ border: '1px solid #4285F4' }}
    >
      <div className='logo-wrapper' style={{ marginRight: '8px' }}>
        <img src='https://developers.google.com/identity/images/g-logo.png' alt='Google Logo' style={{ height: '24px' }} />
      </div>
      Sign in with Google
    </button>
  );
};

export default GoogleLoginButton;
